import { useId } from 'react';
import { colors } from '@ardoq/design-tokens';

export const AiBadgeIconGradient = () => {
  const id = useId().replace(/[^a-z0-9]/gi, '');
  const gradientId = `ai-badge-gradient-${id}`;
  return (
    <svg
      width={32}
      height={25}
      viewBox="0 0 32 25"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M10.8255 18H8.85671L12.4412 7.81818H14.7182L18.3077 18H16.339L13.6195 9.90625H13.54L10.8255 18ZM10.8901 14.0078H16.2594V15.4893H10.8901V14.0078ZM21.4933 7.81818V18H19.6488V7.81818H21.4933Z"
        fill={colors.grey600}
      />
      <path
        d="M30.5 11.5V20.5C30.5 22.7091 28.7091 24.5 26.5 24.5H4.5C2.29086 24.5 0.5 22.7091 0.5 20.5V4.5C0.5 2.29086 2.29086 0.5 4.5 0.5H19.5"
        stroke={`url(#${gradientId})`}
      />
      <path
        d="M28.4779 6.85723H27.0834V9.6H25.6877V6.85664H27.0822V5.48555H28.4779V6.85723Z"
        fill={colors.orange500}
      />
      <path
        d="M25.6877 6.85664H24.2914V5.48555H25.6871L25.6877 6.85664Z"
        fill={colors.orange500}
      />
      <path
        d="M27.0828 2.74277H28.4779V4.11445H27.0822L27.0828 2.74277H25.6871V4.11445H24.2914V5.48555H21.5V4.11445H24.2914V2.74277H25.6871V0H27.0828V2.74277Z"
        fill={colors.orange500}
      />
      <path
        d="M31.1 5.48555H28.4779V4.11445H31.1V5.48555Z"
        fill={colors.orange500}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0.5"
          y1="12.5"
          x2="30.5"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.brand300} />
          <stop offset="0.943415" stopColor={colors.orange500} />
        </linearGradient>
      </defs>
    </svg>
  );
};
